import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/* ──────────────────────────────────────────────────────────────
 *  Coquille de modale partagée : backdrop flouté + centrage +
 *  fermeture au clic extérieur + portail sur document.body.
 *  La carte intérieure garde ses propres classes (`className`),
 *  donc chaque modale conserve exactement son apparence d'origine.
 * ────────────────────────────────────────────────────────────── */

export default function Modal({
  onClose,
  className = '',
  zClassName = 'z-[100]',
  children,
}: {
  onClose: () => void;
  /** Classes de la carte intérieure (mêmes que l'ancien markup inline). */
  className?: string;
  /** z-index du backdrop (défaut z-[100], cf. modale email d'origine). */
  zClassName?: string;
  children: ReactNode;
}) {
  return createPortal(
    <div
      className={`fixed inset-0 ${zClassName} flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-fade-in`}
      onClick={onClose}
    >
      <div onClick={(e) => e.stopPropagation()} className={className}>
        {children}
      </div>
    </div>,
    document.body,
  );
}
